// $.user по требованиям для СОПР 1.0 https://cianru.atlassian.net/wiki/spaces/ML/pages/443613219
import { IApplicationState } from '../../../types/redux';
import { TUser } from '../../../types/analytics';

export function createUserTrackingData(state: IApplicationState): TUser {
  const { userData, lkType } = state;

  if (!userData) {
    return { type: 'not_authorized' };
  }

  return {
    cianUserId: userData.cianUserId,
    email: userData.email,
    type: lkType,
    userId: userData.realtyUserId,
  };
}
